module.exports = __webpack_public_path__ + "static/Ginger@2x.df41a6d3.png";